import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import asFormField from './asFormField';
import { SelectInput } from './SelectField';

export const TypeaheadInput = ({
    onInputChange,
    ...rest
}) => {
    const debouncedInputChange = useMemo(() => debounce(onInputChange, 300), [onInputChange]);

    const handleInputChange = (newInputValue, actionMeta) => {
        if (actionMeta.action === 'input-change') {
            return debouncedInputChange(newInputValue, actionMeta);
        }

        onInputChange(newInputValue, actionMeta);
    };

    return (
        <SelectInput
            {...rest}
            filterOptionType="all"
            onInputChange={handleInputChange}
        />
    );
};

TypeaheadInput.propTypes = {
    onInputChange: PropTypes.func.isRequired,
};

export const TypeaheadField = asFormField({ WrappedComponent: React.memo(TypeaheadInput) });
